import api from "./index";

import cookiesHelper from "../helpers/cookies";

import { ISavePassport } from "../interfaces/services";

export const savePassports = async (data: ISavePassport[]) => {
    const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.post(`passports`, data);
        return res.data;
    } catch (error: any) {
        throw error?.response?.data;
    };
};

export const savePassport = async (data: ISavePassport) => {
    const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.post(`passports`, data);
        return res.data;
    } catch (error: any) {
        throw error?.response?.data;
    };
};

export const deletePassport = async (id: number) => {
    const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.patch(`passports/delete/${id}`);
        return res.data;
    } catch (error: any) {
        throw error?.response?.data;
    };
};